import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { API_BASE } from './api-base';

let app: FirebaseApp;
let authInstance: Auth;
let initPromise: Promise<void> | null = null;

async function init() {
  // Prefer build-time env vars if available, otherwise fetch from worker
  let apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  let authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID || 'stash-app-gw';

  if (!apiKey || !authDomain) {
    const res = await fetch(`${API_BASE}/api/config`);
    const config = await res.json();
    apiKey = config.firebaseApiKey;
    authDomain = config.firebaseAuthDomain;
  }

  app = initializeApp({ apiKey, authDomain, projectId });
  authInstance = getAuth(app);
}

export function ensureFirebase(): Promise<void> {
  if (!initPromise) {
    initPromise = init();
  }
  return initPromise;
}

// Lazy accessors — callers must await ensureFirebase() first
export { authInstance as auth };
export default app!;
